import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';

// TODO: replace / combine with form-js-date!
@Component({
  selector: 'ngx-form-date',
  templateUrl: './form-date.component.html',
  styleUrls: ['./form-date.component.scss'],
})
export class FormDateComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() value: string;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  dateModel: NgbDateStruct;

  public dateValue: Date;
  constructor() {
    this.dateValue = new Date();
  }

  ngOnInit() {
    if (this.value != null && this.value !== '')
      this.dateValue = new Date(this.value);
    this.setModel(this.dateValue);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dateValue = changes.value.currentValue;
    this.setModel(this.dateValue);
  }

  setModel(date: Date) {
    if (date) date = new Date(date);
    this.dateModel = date ? { day: date.getUTCDate(), month: date.getUTCMonth()+1, year: date.getUTCFullYear() } : null;
  }


  // update(date: Date) {
  //   this.value = date.toISOString();
  //   // console.log(date.getTimezoneOffset());
  //   this.valueChange.emit(moment(date).subtract('m', date.getTimezoneOffset()).toISOString());
  // }

  updateDate(ngbDate: NgbDateStruct) {
    const jsDate = new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day);
    this.value = jsDate.toISOString();
    this.valueChange.emit(moment(jsDate).subtract('m', jsDate.getTimezoneOffset()).toISOString());
  }

  clear() {
    this.value = null;
    this.valueChange.emit(null);
  }
}
